const checkHasSubcategory = (
  categoryId: number,
  categoriesTree: string[] | undefined
): boolean => {
  const categoryIdStringBegin = `${categoryId}/`;
  const categoryIdStringMiddle = `/${categoryId}/`;

  return (
    categoriesTree?.some((categoryPath) => {
      switch (true) {
        case categoryPath.indexOf(categoryIdStringBegin) === 0:
        case categoryPath.indexOf(categoryIdStringMiddle) !== -1: {
          return true;
        }
        default: {
          return false;
        }
      }
    }) || false
  );
};

export default checkHasSubcategory;
